import { derived } from "svelte/store"
import { page } from "@inertiajs/svelte"

export default derived(page, ($page) => $page.props.account)
